export default path => '/tires/electric-vehicle-tires'.includes(path)
